import StateRouter from 'abstract-state-router'
import SvelteRenderer from 'svelte-state-renderer'
import setupServices from '@legacy/client/service/index.js'
import legacyRendererDefaults from '@legacy/client/rendererDefaults'

const MAXIMUM_STATE_ROUTE_LISTENERS = 20
const BASE_API_URL = '/api'

const service = setupServices({
    baseApiUrl: BASE_API_URL
})

export const api = service.api
export const log = service.logger

export const stateRouter = StateRouter(SvelteRenderer(legacyRendererDefaults), document.querySelector('body'))
stateRouter.setMaxListeners(MAXIMUM_STATE_ROUTE_LISTENERS)
